module.exports = __webpack_public_path__ + "static/media/treasure-chest.ec3c68d0.svg";